// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddCodelistEndpointData, AddCodelistEndpointResponses, AssignInstructionEndpointData, AssignInstructionEndpointErrors, AssignInstructionEndpointResponses, CancelInstructionEndpointData, CancelInstructionEndpointErrors, CancelInstructionEndpointResponses, CancelOrderEndpointData, CancelOrderEndpointErrors, CancelOrderEndpointResponses, CreateOrganizationEndpointData, CreateOrganizationEndpointErrors, CreateOrganizationEndpointResponses, CreateRoleEndpointData, CreateRoleEndpointErrors, CreateRoleEndpointResponses, CreateTruckEndpointData, CreateTruckEndpointErrors, CreateTruckEndpointResponses, CreateUserEndpointData, CreateUserEndpointErrors, CreateUserEndpointResponses, CreateWarehouseEndpointData, CreateWarehouseEndpointErrors, CreateWarehouseEndpointResponses, DeleteTruckEndpointData, DeleteTruckEndpointErrors, DeleteTruckEndpointResponses, DeleteUserEndpointData, DeleteUserEndpointErrors, DeleteUserEndpointResponses, DeleteWarehouseEndpointData, DeleteWarehouseEndpointErrors, DeleteWarehouseEndpointResponses, EndpointData, EndpointResponses, GetApplicationSettingListEndpointData, GetApplicationSettingListEndpointErrors, GetApplicationSettingListEndpointResponses, GetCodelistsEndpointData, GetCodelistsEndpointResponses, GetCurrentUserEndpointData, GetCurrentUserEndpointErrors, GetCurrentUserEndpointResponses, GetGridSettingsEndpointData, GetGridSettingsEndpointErrors, GetGridSettingsEndpointResponses, GetLoginApplicationSettingsEndpointData, GetLoginApplicationSettingsEndpointResponses, GetOrganizationEmailCategoryStatesEndpointData, GetOrganizationEmailCategoryStatesEndpointErrors, GetOrganizationEmailCategoryStatesEndpointResponses, GetOrganizationEndpointData, GetOrganizationEndpointErrors, GetOrganizationEndpointResponses, GetRoleEmailCategoryStatesEndpointData, GetRoleEmailCategoryStatesEndpointErrors, GetRoleEmailCategoryStatesEndpointResponses, GetRoleEndpointData, GetRoleEndpointErrors, GetRoleEndpointResponses, GetSettingsEndpointData, GetSettingsEndpointErrors, GetSettingsEndpointResponses, GetTruckEndpointData, GetTruckEndpointErrors, GetTruckEndpointResponses, GetUserEmailPreferencesEndpointData, GetUserEmailPreferencesEndpointErrors, GetUserEmailPreferencesEndpointResponses, GetUserEndpointData, GetUserEndpointErrors, GetUserEndpointResponses, GetUserSettingListEndpointData, GetUserSettingListEndpointErrors, GetUserSettingListEndpointResponses, GetWarehouseEndpointData, GetWarehouseEndpointErrors, GetWarehouseEndpointResponses, HealthEndpointData, HealthEndpointResponses, HoldInstructionEndpointData, HoldInstructionEndpointErrors, HoldInstructionEndpointResponses, HoldOrderEndpointData, HoldOrderEndpointErrors, HoldOrderEndpointResponses, IsAuthenticatedEndpointData, IsAuthenticatedEndpointErrors, IsAuthenticatedEndpointResponses, ListInstructionsEndpointData, ListInstructionsEndpointErrors, ListInstructionsEndpointResponses, ListOrdersEndpointData, ListOrdersEndpointErrors, ListOrdersEndpointResponses, ListOrganizationsEndpointData, ListOrganizationsEndpointErrors, ListOrganizationsEndpointResponses, ListPermissionsEndpointData, ListPermissionsEndpointErrors, ListPermissionsEndpointResponses, ListRolesEndpointData, ListRolesEndpointErrors, ListRolesEndpointResponses, ListTrucksEndpointData, ListTrucksEndpointErrors, ListTrucksEndpointResponses, ListUserEndpointData, ListUserEndpointErrors, ListUserEndpointResponses, ListWarehousesEndpointData, ListWarehousesEndpointErrors, ListWarehousesEndpointResponses, LoginEndpointData, LoginEndpointErrors, LoginEndpointResponses, LogoutEndpointData, LogoutEndpointErrors, LogoutEndpointResponses, OrganizationCodelistEndpointData, OrganizationCodelistEndpointResponses, PermissionCodelistEndpointData, PermissionCodelistEndpointErrors, PermissionCodelistEndpointResponses, PlanOrderEndpointData, PlanOrderEndpointErrors, PlanOrderEndpointResponses, ReadinessEndpointData, ReadinessEndpointResponses, ResetApplicationSettingsEndpointData, ResetApplicationSettingsEndpointErrors, ResetApplicationSettingsEndpointResponses, ResetUserSettingsEndpointData, ResetUserSettingsEndpointErrors, ResetUserSettingsEndpointResponses, RoleCodelistEndpointData, RoleCodelistEndpointErrors, RoleCodelistEndpointResponses, SaveApplicationSettingsEndpointData, SaveApplicationSettingsEndpointErrors, SaveApplicationSettingsEndpointResponses, SaveGridSettingsEndpointData, SaveGridSettingsEndpointErrors, SaveGridSettingsEndpointResponses, SaveOrganizationEmailCategoryStatesEndpointData, SaveOrganizationEmailCategoryStatesEndpointErrors, SaveOrganizationEmailCategoryStatesEndpointResponses, SaveRoleEmailCategoryStatesEndpointData, SaveRoleEmailCategoryStatesEndpointErrors, SaveRoleEmailCategoryStatesEndpointResponses, SaveUserEmailPreferencesEndpointData, SaveUserEmailPreferencesEndpointErrors, SaveUserEmailPreferencesEndpointResponses, SaveUserSettingsEndpointData, SaveUserSettingsEndpointErrors, SaveUserSettingsEndpointResponses, SendSampleEmailEndpointData, SendSampleEmailEndpointErrors, SendSampleEmailEndpointResponses, SetUserLanguageEndpointData, SetUserLanguageEndpointErrors, SetUserLanguageEndpointResponses, UpdateOrganizationEndpointData, UpdateOrganizationEndpointErrors, UpdateOrganizationEndpointResponses, UpdateRoleEndpointData, UpdateRoleEndpointErrors, UpdateRoleEndpointResponses, UpdateTruckEndpointData, UpdateTruckEndpointErrors, UpdateTruckEndpointResponses, UpdateUserEndpointData, UpdateUserEndpointErrors, UpdateUserEndpointResponses, UpdateWarehouseEndpointData, UpdateWarehouseEndpointErrors, UpdateWarehouseEndpointResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Delete warehouse
 *
 * Deletes a warehouse by ID
 */
export const deleteWarehouseEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteWarehouseEndpointData, ThrowOnError>) => (options.client ?? client).delete<DeleteWarehouseEndpointResponses, DeleteWarehouseEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/warehouses/{id}',
    ...options
});

/**
 * Get warehouse by ID
 *
 * Retrieves a specific warehouse by ID
 */
export const getWarehouseEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseEndpointData, ThrowOnError>) => (options.client ?? client).get<GetWarehouseEndpointResponses, GetWarehouseEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/warehouses/{id}',
    ...options
});

/**
 * Update a warehouse
 *
 * Update an existing warehouse
 */
export const updateWarehouseEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseEndpointData, ThrowOnError>) => (options.client ?? client).patch<UpdateWarehouseEndpointResponses, UpdateWarehouseEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/warehouses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get warehouses
 *
 * Retrieves a list of all warehouses
 */
export const listWarehousesEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ListWarehousesEndpointData, ThrowOnError>) => (options?.client ?? client).get<ListWarehousesEndpointResponses, ListWarehousesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/warehouses',
    ...options
});

/**
 * Create a warehouse
 *
 * Create a new warehouse
 */
export const createWarehouseEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseEndpointData, ThrowOnError>) => (options.client ?? client).post<CreateWarehouseEndpointResponses, CreateWarehouseEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/warehouses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete truck
 *
 * Deletes a truck by ID
 */
export const deleteTruckEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteTruckEndpointData, ThrowOnError>) => (options.client ?? client).delete<DeleteTruckEndpointResponses, DeleteTruckEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trucks/{id}',
    ...options
});

/**
 * Get truck by ID
 *
 * Retrieves a specific truck by ID
 */
export const getTruckEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetTruckEndpointData, ThrowOnError>) => (options.client ?? client).get<GetTruckEndpointResponses, GetTruckEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trucks/{id}',
    ...options
});

/**
 * Update a truck
 *
 * Update an existing truck
 */
export const updateTruckEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateTruckEndpointData, ThrowOnError>) => (options.client ?? client).patch<UpdateTruckEndpointResponses, UpdateTruckEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trucks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get trucks
 *
 * Retrieves a list of all trucks
 */
export const listTrucksEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ListTrucksEndpointData, ThrowOnError>) => (options?.client ?? client).get<ListTrucksEndpointResponses, ListTrucksEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trucks',
    ...options
});

/**
 * Create a truck
 *
 * Create a new truck
 */
export const createTruckEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateTruckEndpointData, ThrowOnError>) => (options.client ?? client).post<CreateTruckEndpointResponses, CreateTruckEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trucks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * I18N Localization
 *
 * Example of I18N Service localization
 */
export const endpoint = <ThrowOnError extends boolean = false>(options: Options<EndpointData, ThrowOnError>) => (options.client ?? client).post<EndpointResponses, unknown, ThrowOnError>({
    url: '/api/tests/localization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save user settings
 *
 * Updates or creates user setting overrides for the current user
 */
export const saveUserSettingsEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveUserSettingsEndpointData, ThrowOnError>) => (options.client ?? client).post<SaveUserSettingsEndpointResponses, SaveUserSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset user settings to defaults
 *
 * Deletes all user setting overrides for the current user, reverting to application defaults
 */
export const resetUserSettingsEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ResetUserSettingsEndpointData, ThrowOnError>) => (options?.client ?? client).post<ResetUserSettingsEndpointResponses, ResetUserSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/user/reset',
    ...options
});

/**
 * Get user-editable settings
 *
 * Returns all user-editable setting definitions with current user's customized values and defaults
 */
export const getUserSettingListEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetUserSettingListEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetUserSettingListEndpointResponses, GetUserSettingListEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/user/list',
    ...options
});

/**
 * Save application settings
 *
 * Updates multiple application setting values (admin only)
 */
export const saveApplicationSettingsEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveApplicationSettingsEndpointData, ThrowOnError>) => (options.client ?? client).post<SaveApplicationSettingsEndpointResponses, SaveApplicationSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/application',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset application settings to defaults
 *
 * Deletes all application settings and re-seeds with default values (admin only)
 */
export const resetApplicationSettingsEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ResetApplicationSettingsEndpointData, ThrowOnError>) => (options?.client ?? client).post<ResetApplicationSettingsEndpointResponses, ResetApplicationSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/application/reset',
    ...options
});

/**
 * Save grid settings for the current user
 *
 * Creates or updates grid settings for the provided key
 */
export const saveGridSettingsEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveGridSettingsEndpointData, ThrowOnError>) => (options.client ?? client).post<SaveGridSettingsEndpointResponses, SaveGridSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/grid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get settings for provided grid key
 *
 * Returns grid settings for provided grid key
 */
export const getGridSettingsEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetGridSettingsEndpointData, ThrowOnError>) => (options.client ?? client).get<GetGridSettingsEndpointResponses, GetGridSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/grid/{key}',
    ...options
});

/**
 * Get effective runtime settings
 *
 * Returns merged application and user settings - user settings override application defaults
 */
export const getSettingsEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsEndpointResponses, GetSettingsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings',
    ...options
});

/**
 * Get login settings
 *
 * Returns application settings required for the login page (publicly accessible)
 */
export const getLoginApplicationSettingsEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetLoginApplicationSettingsEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetLoginApplicationSettingsEndpointResponses, unknown, ThrowOnError>({ url: '/api/settings/login', ...options });

/**
 * Get all application settings
 *
 * Returns all application setting definitions with their current values for administrative management
 */
export const getApplicationSettingListEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetApplicationSettingListEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetApplicationSettingListEndpointResponses, GetApplicationSettingListEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/application/list',
    ...options
});

/**
 * Plan an order
 *
 * Assigns a truck to an order, sets status to Planned, and creates an Instruction
 */
export const planOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<PlanOrderEndpointData, ThrowOnError>) => (options.client ?? client).patch<PlanOrderEndpointResponses, PlanOrderEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/orders/{id}/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get orders
 *
 * Retrieves a list of all orders
 */
export const listOrdersEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ListOrdersEndpointData, ThrowOnError>) => (options?.client ?? client).get<ListOrdersEndpointResponses, ListOrdersEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/orders',
    ...options
});

/**
 * Put an order on hold
 *
 * Sets an order status to On Hold with a remark
 */
export const holdOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<HoldOrderEndpointData, ThrowOnError>) => (options.client ?? client).patch<HoldOrderEndpointResponses, HoldOrderEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/orders/{id}/hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel an order
 *
 * Sets an order status to Cancelled with a remark
 */
export const cancelOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<CancelOrderEndpointData, ThrowOnError>) => (options.client ?? client).patch<CancelOrderEndpointResponses, CancelOrderEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/orders/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get instructions
 *
 * Retrieves a list of all instructions
 */
export const listInstructionsEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ListInstructionsEndpointData, ThrowOnError>) => (options?.client ?? client).get<ListInstructionsEndpointResponses, ListInstructionsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/instructions',
    ...options
});

/**
 * Put an instruction on hold
 *
 * Sets an instruction status to On Hold with a remark
 */
export const holdInstructionEndpoint = <ThrowOnError extends boolean = false>(options: Options<HoldInstructionEndpointData, ThrowOnError>) => (options.client ?? client).patch<HoldInstructionEndpointResponses, HoldInstructionEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/instructions/{id}/hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel an instruction
 *
 * Sets an instruction status to Cancelled with a remark
 */
export const cancelInstructionEndpoint = <ThrowOnError extends boolean = false>(options: Options<CancelInstructionEndpointData, ThrowOnError>) => (options.client ?? client).patch<CancelInstructionEndpointResponses, CancelInstructionEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/instructions/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign an instruction
 *
 * Updates truck and destination for an instruction and sets status to Assigned
 */
export const assignInstructionEndpoint = <ThrowOnError extends boolean = false>(options: Options<AssignInstructionEndpointData, ThrowOnError>) => (options.client ?? client).patch<AssignInstructionEndpointResponses, AssignInstructionEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/instructions/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current user email category preferences
 *
 * Returns explicit user preference and effective availability per email category.
 */
export const getUserEmailPreferencesEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetUserEmailPreferencesEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetUserEmailPreferencesEndpointResponses, GetUserEmailPreferencesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/email-categories/me',
    ...options
});

/**
 * Save current user email category preferences
 *
 * Upserts explicit user-level email category preferences.
 */
export const saveUserEmailPreferencesEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveUserEmailPreferencesEndpointData, ThrowOnError>) => (options.client ?? client).put<SaveUserEmailPreferencesEndpointResponses, SaveUserEmailPreferencesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/email-categories/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Queue sample email
 *
 * Enqueues a sample email into the Hangfire emails queue.
 */
export const sendSampleEmailEndpoint = <ThrowOnError extends boolean = false>(options: Options<SendSampleEmailEndpointData, ThrowOnError>) => (options.client ?? client).post<SendSampleEmailEndpointResponses, SendSampleEmailEndpointErrors, ThrowOnError>({
    url: '/api/emailing/sample',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness probe
 *
 * Returns immediately when the API process is running.
 */
export const healthEndpoint = <ThrowOnError extends boolean = false>(options?: Options<HealthEndpointData, ThrowOnError>) => (options?.client ?? client).get<HealthEndpointResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Readiness probe
 *
 * Checks connectivity to critical dependencies.
 */
export const readinessEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ReadinessEndpointData, ThrowOnError>) => (options?.client ?? client).get<ReadinessEndpointResponses, unknown, ThrowOnError>({ url: '/api/ready', ...options });

/**
 * Query codelist entities
 *
 * Generic endpoint for querying codelist entities with filtering
 */
export const getCodelistsEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetCodelistsEndpointData, ThrowOnError>) => (options.client ?? client).get<GetCodelistsEndpointResponses, unknown, ThrowOnError>({ url: '/api/codelist/{codelist}', ...options });

export const addCodelistEndpoint = <ThrowOnError extends boolean = false>(options: Options<AddCodelistEndpointData, ThrowOnError>) => (options.client ?? client).post<AddCodelistEndpointResponses, unknown, ThrowOnError>({
    url: '/api/codelist/{codelist}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change user language
 *
 * Change user language setting for logged in user
 */
export const setUserLanguageEndpoint = <ThrowOnError extends boolean = false>(options: Options<SetUserLanguageEndpointData, ThrowOnError>) => (options.client ?? client).post<SetUserLanguageEndpointResponses, SetUserLanguageEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/authentication/set-user-language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout user
 *
 * Sign out user and clear session cookie
 */
export const logoutEndpoint = <ThrowOnError extends boolean = false>(options?: Options<LogoutEndpointData, ThrowOnError>) => (options?.client ?? client).post<LogoutEndpointResponses, LogoutEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/authentication/logout',
    ...options
});

/**
 * Login user
 *
 * Authenticate user and create session cookie
 */
export const loginEndpoint = <ThrowOnError extends boolean = false>(options: Options<LoginEndpointData, ThrowOnError>) => (options.client ?? client).post<LoginEndpointResponses, LoginEndpointErrors, ThrowOnError>({
    url: '/api/authentication/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checks if the request contains valid cookie
 */
export const isAuthenticatedEndpoint = <ThrowOnError extends boolean = false>(options?: Options<IsAuthenticatedEndpointData, ThrowOnError>) => (options?.client ?? client).get<IsAuthenticatedEndpointResponses, IsAuthenticatedEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/authentication/is-authenticated',
    ...options
});

/**
 * Get logged in user
 *
 * Used for cookie-based authentication on the frontend
 */
export const getCurrentUserEndpoint = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserEndpointData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserEndpointResponses, GetCurrentUserEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/authentication/current-user',
    ...options
});

/**
 * Delete user
 *
 * Deletes a user by their ID
 */
export const deleteUserEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteUserEndpointData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserEndpointResponses, DeleteUserEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Get user by ID
 *
 * Retrieves a specific user by their ID
 */
export const getUserEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetUserEndpointData, ThrowOnError>) => (options.client ?? client).get<GetUserEndpointResponses, GetUserEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Update user
 *
 * Updates an existing user's information
 */
export const updateUserEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateUserEndpointData, ThrowOnError>) => (options.client ?? client).put<UpdateUserEndpointResponses, UpdateUserEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get users
 *
 * Retrieves a list of users
 */
export const listUserEndpoint = <ThrowOnError extends boolean = false>(options: Options<ListUserEndpointData, ThrowOnError>) => (options.client ?? client).get<ListUserEndpointResponses, ListUserEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options
});

/**
 * Create a new user
 *
 * Creates a new user and returns the created user data
 */
export const createUserEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateUserEndpointData, ThrowOnError>) => (options.client ?? client).post<CreateUserEndpointResponses, CreateUserEndpointErrors, ThrowOnError>({
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get role by ID
 *
 * Retrieves a specific role by ID
 */
export const getRoleEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetRoleEndpointData, ThrowOnError>) => (options.client ?? client).get<GetRoleEndpointResponses, GetRoleEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/{id}',
    ...options
});

/**
 * Update a role
 *
 * Update an existing role
 */
export const updateRoleEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleEndpointData, ThrowOnError>) => (options.client ?? client).patch<UpdateRoleEndpointResponses, UpdateRoleEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get roles
 *
 * Retrieves a list of roles
 */
export const listRolesEndpoint = <ThrowOnError extends boolean = false>(options: Options<ListRolesEndpointData, ThrowOnError>) => (options.client ?? client).get<ListRolesEndpointResponses, ListRolesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles',
    ...options
});

/**
 * Create a role
 *
 * Create a new role
 */
export const createRoleEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateRoleEndpointData, ThrowOnError>) => (options.client ?? client).post<CreateRoleEndpointResponses, CreateRoleEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query codelist entities
 *
 * Generic endpoint for querying codelist entities with filtering
 */
export const roleCodelistEndpoint = <ThrowOnError extends boolean = false>(options: Options<RoleCodelistEndpointData, ThrowOnError>) => (options.client ?? client).get<RoleCodelistEndpointResponses, RoleCodelistEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/codelist/role',
    ...options
});

/**
 * Get permissions
 *
 * Retrieves a list of permissions
 */
export const listPermissionsEndpoint = <ThrowOnError extends boolean = false>(options: Options<ListPermissionsEndpointData, ThrowOnError>) => (options.client ?? client).get<ListPermissionsEndpointResponses, ListPermissionsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/permissions',
    ...options
});

/**
 * Query permission codelist entities
 *
 * Endpoint for querying permission codelist entities with filtering
 */
export const permissionCodelistEndpoint = <ThrowOnError extends boolean = false>(options: Options<PermissionCodelistEndpointData, ThrowOnError>) => (options.client ?? client).get<PermissionCodelistEndpointResponses, PermissionCodelistEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/codelist/permission',
    ...options
});

/**
 * Get organization by ID
 *
 * Retrieves a specific organization by ID
 */
export const getOrganizationEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationEndpointData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationEndpointResponses, GetOrganizationEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{id}',
    ...options
});

/**
 * Update an organization
 *
 * Update an existing organization
 */
export const updateOrganizationEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationEndpointData, ThrowOnError>) => (options.client ?? client).patch<UpdateOrganizationEndpointResponses, UpdateOrganizationEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organizations
 *
 * Retrieves a list of organizations
 */
export const listOrganizationsEndpoint = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationsEndpointData, ThrowOnError>) => (options.client ?? client).get<ListOrganizationsEndpointResponses, ListOrganizationsEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations',
    ...options
});

/**
 * Create an organization
 *
 * Create a new organization
 */
export const createOrganizationEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationEndpointData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationEndpointResponses, CreateOrganizationEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query organization codelist entities
 *
 * Endpoint for querying organization codelist entities with filtering
 */
export const organizationCodelistEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrganizationCodelistEndpointData, ThrowOnError>) => (options.client ?? client).get<OrganizationCodelistEndpointResponses, unknown, ThrowOnError>({ url: '/api/codelist/organizations', ...options });

/**
 * Get role email category states
 *
 * Returns all email categories and explicit role state overrides.
 */
export const getRoleEmailCategoryStatesEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetRoleEmailCategoryStatesEndpointData, ThrowOnError>) => (options.client ?? client).get<GetRoleEmailCategoryStatesEndpointResponses, GetRoleEmailCategoryStatesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/email-categories/role/{roleId}',
    ...options
});

/**
 * Save role email category states
 *
 * Upserts explicit role-level email category overrides.
 */
export const saveRoleEmailCategoryStatesEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveRoleEmailCategoryStatesEndpointData, ThrowOnError>) => (options.client ?? client).put<SaveRoleEmailCategoryStatesEndpointResponses, SaveRoleEmailCategoryStatesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/email-categories/role/{roleId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization email category states
 *
 * Returns all email categories and explicit organization state overrides.
 */
export const getOrganizationEmailCategoryStatesEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationEmailCategoryStatesEndpointData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationEmailCategoryStatesEndpointResponses, GetOrganizationEmailCategoryStatesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/email-categories/organization/{organizationId}',
    ...options
});

/**
 * Save organization email category states
 *
 * Upserts explicit organization-level email category overrides.
 */
export const saveOrganizationEmailCategoryStatesEndpoint = <ThrowOnError extends boolean = false>(options: Options<SaveOrganizationEmailCategoryStatesEndpointData, ThrowOnError>) => (options.client ?? client).put<SaveOrganizationEmailCategoryStatesEndpointResponses, SaveOrganizationEmailCategoryStatesEndpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/email-categories/organization/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
